/**
 * @generated SignedSource<<14c5d92a33c81e5787f139454bfc74ff>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type MemberReportContentUsagesViewedStatisticsCardFragment$data = {
  readonly contentUsagesViewedReport: {
    readonly totalAvailable: number;
    readonly totalViewed: number;
  };
  readonly " $fragmentType": "MemberReportContentUsagesViewedStatisticsCardFragment";
};
export type MemberReportContentUsagesViewedStatisticsCardFragment$key = {
  readonly " $data"?: MemberReportContentUsagesViewedStatisticsCardFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"MemberReportContentUsagesViewedStatisticsCardFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [
    {
      "defaultValue": null,
      "kind": "LocalArgument",
      "name": "startDate"
    }
  ],
  "kind": "Fragment",
  "metadata": null,
  "name": "MemberReportContentUsagesViewedStatisticsCardFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "startDate",
          "variableName": "startDate"
        }
      ],
      "concreteType": "OrganizationMembershipReportingContentUsagesViewedReportResponse",
      "kind": "LinkedField",
      "name": "contentUsagesViewedReport",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalViewed",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "totalAvailable",
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "OrganizationMembership",
  "abstractKey": null
};

(node as any).hash = "9ffcc8c8d35bf3c4647d1a0cecf37829";

export default node;
